import { da, enGB, fi, nb, sv } from 'date-fns/locale'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import da_trans from './i18_da.json'
import en_trans from './i18_en.json'
import fi_trans from './i18_fi.json'
import no_trans from './i18_no.json'
import sv_trans from './i18_sv.json'

export const resources = {
  sv: { translation: sv_trans, datefns: sv },
  en: { translation: en_trans, datefns: enGB },
  da: { translation: da_trans, datefns: da },
  no: { translation: no_trans, datefns: nb },
  fi: { translation: fi_trans, datefns: fi },
}
const supportedLanguages = Object.keys(resources)
const defaultLanguage = 'sv'
let lng = defaultLanguage
try {
  const lslng = localStorage.getItem('lng')
  if (lslng) {
    lng = JSON.parse(lslng)
  } else {
    const browserLang = navigator.language?.split('-')[0]
    if (browserLang && supportedLanguages.includes(browserLang)) {
      lng = browserLang
    } else {
      lng = 'en'
    }
  }
  localStorage.setItem('lng', JSON.stringify(lng))
} catch (err) {
  // localStorage unavailable or corrupt — use default language
}
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng,
    fallbackLng: defaultLanguage,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
